import type { ComponentType } from "react";
import type { RendererProps } from "./types";
import { TopicPlanReview } from "./topic-plan-review";
import { ChipRailReview } from "./chip-rail-review";
import { DiscussionReview } from "./discussion-review";
import { GenericPlanFallback } from "./generic-plan-fallback";
import { LectureMarkingRenderer } from "./lecture-marking";

// Maps an awaiting_user step's part_slug to its web renderer. Mirrors the iOS
// FrameworkRunnerView routing (by part_slug). Slugs not listed here fall back to
// GenericPlanFallback — the web equivalent of AnyQuestion.unknown: render
// gracefully, don't break the run.
const REGISTRY: Record<string, ComponentType<RendererProps>> = {
  // topic-plan family — schema-identical (confirmed)
  "headteacher.topic-plan": TopicPlanReview,
  "headteacher.math-topic-plan": TopicPlanReview,
  "headteacher.de-grammar-topic-plan": TopicPlanReview,
  // language-trainer Pass 1: same topics + per-topic depth/count response
  // (an extra `proposed_modes` slate is ignored). Pass 2
  // (headteacher.language-compose-structure) runs without a pause.
  "headteacher.language-plan": TopicPlanReview,
  // chip-rail family — reuse LectureExerciseUserResponse
  "headteacher.lecture-exercise-plan": ChipRailReview, // confirmed
  "headteacher.math-tutor-plan": ChipRailReview, // confirmed (reuses the schema)
  "headteacher.learn-plan": ChipRailReview, // optimistic (shared iOS renderer)
  "headteacher.deep-plan": ChipRailReview, // optimistic (shared iOS renderer)
  // unified multi-agent planner — 3-slide checkpoint (topics+depth / info cards
  // / structure+length). Mirrors iOS DiscussionReviewView.
  "headteacher.discussion": DiscussionReview,
  // lecture PDF marking — pdf.js render + region-snip + multimodal explain
  "lecture.marking": LectureMarkingRenderer,
};

export function rendererFor(partSlug: string): ComponentType<RendererProps> {
  return REGISTRY[partSlug] ?? GenericPlanFallback;
}
